import styled, { css } from 'styled-components';
import {
  desktop_breakpoint_extended,
  mobile_width_percentage,
  tablet_portrait_breakpoint,
} from 'pubweb-smokey/dist/components/GridSystem/_vars_widths.js';
import Colors from 'pubweb-smokey/dist/colors';

const sharedStyles = css`
  margin: 0 auto 60px;
  width: ${mobile_width_percentage}%;

  h2 {
    font-size: 18px;
    margin-bottom: 1.5rem;
  }

  .image-grid {
    box-shadow: rgb(0 0 0 / 20%) 0px 3px 7px 0px;
    padding: 16px;
    text-align: center;
  }
`;

export const ImageGridStyles = styled.div`
  ${sharedStyles};

  .image-grid {
    .link {
      margin-bottom: 0;
    }
  }

  .image-list {
    display: grid;
    gap: 10px;
    grid-template-columns: repeat(2, 1fr);
    list-style: none;
    margin-bottom: 20px;
    padding: 0;
    width: 100%;
  }

  .image-list-item {
    position: relative;
    line-height: 0;

    img {
      object-fit: cover;
      width: 37vw;
      height: 37vw;
    }
  }

  .instagram-tile {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.6);
    display: flex;
    align-items: center;
    justify-content: center;

    svg {
      width: 75px;
      height: 75px;
    }

    path {
      fill: ${Colors.primary.white.standard};
    }
  }

  @media screen and (min-width: 768px) {
    margin-bottom: 100px;
    width: 500px;

    .image-grid {
      padding: 34px;
    }

    .image-list {
      gap: 24px;
      margin-bottom: 28px;
    }

    .image-list-item {
      img {
        width: 204px;
        height: 204px;
      }
    }
  }

  @media screen and (max-width: 1023px) {
    .image-list-item:nth-child(5) {
      display: none;
    }
  }

  @media screen and (min-width: ${desktop_breakpoint_extended}px) {
    width: ${mobile_width_percentage}%;

    h2 {
      font-size: 28px;
    }

    .image-list {
      grid-auto-flow: column;
      grid-template-columns: repeat(4, 1fr);
      grid-template-rows: repeat(2, 1fr);
    }

    .image-list-item.wide {
      grid-column-end: span 2;
      grid-row-end: span 2;
    }

    .image-list-item {
      img {
        width: 100%;
        height: 100%;
      }
    }

    .instagram-tile {
      svg {
        width: 90px;
        height: 90px;
      }
    }
  }
`;

export const CuratedCollectionStyles = styled.div`
  ${sharedStyles};
  .image-grid {
    .link {
      margin-top: 20px;
      margin-bottom: 14px;
    }
  }

  .image-list {
    list-style: none;
    padding: 0;
    width: 100%;

    li + li {
      margin-top: 1rem;
    }
  }

  .image-list-item {
    position: relative;
    width: 100%;

    img {
      border-radius: 6px;
      object-fit: cover;
      width: 100%;
      height: 100%;
    }

    .image-list-item-image {
      height: 24.1vw;
    }

    h5 {
      width: 100%;
      border-radius: 0 0 6px 6px;
      text-align: left;
      color: ${Colors.primary.white.standard};
      position: absolute;
      padding-left: 16px;
      bottom: 0;
      font-family: 'source-sans-pro', sans-serif;
      font-weight: 600;
      font-size: 18px;
      line-height: 38px;
      letter-spacing: -0.35px;
      text-shadow: 0 0 3px black;
      background: linear-gradient(
        180deg,
        rgba(44, 44, 44, 0) 0%,
        rgba(44, 44, 44, 0.8) 100%
      );
    }
  }

  @media screen and (min-width: ${tablet_portrait_breakpoint}px) {
    width: 500px;

    .image-list-item {
      .image-list-item-image {
        height: 18.2vw;
      }
    }
  }

  @media screen and (min-width: ${desktop_breakpoint_extended}px) {
    width: ${mobile_width_percentage}%;

    h2 {
      font-size: 28px;
    }

    .image-grid {
      padding: 15px;
    }

    .image-list {
      display: grid;
      gap: 10px;
      grid-template-columns: repeat(3, 1fr);

      li + li {
        margin: 0;
      }
    }

    .image-list-item {
      .image-list-item-image {
        height: 11vh;
      }
    }
  }

  @media screen and (min-width: 1300px) {
    max-width: 1100px;

    .image-list {
      gap: 20px;
    }

    .image-list-item {
      h5 {
        font-size: 22px;
      }
      img {
        object-fit: cover;
        width: 100%;
      }
      .image-list-item-image {
        height: 12vh;
      }
      width: 100%;
    }
  }
`;
